import { createAction } from 'typesafe-actions';
import { LayoutViewMode } from './layout.reducer';

export const layoutSideNavCollapse = createAction('SIDE_NAV_COLLAPSE')<{ collapse: boolean }>();

export const layoutViewMode = createAction('LAYOUT_VIEW')<{ viewMode: LayoutViewMode }>();
